import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import 'Components/atoms/vm-button-next/vm-button-next';
import 'Components/atoms/vm-clamped-text/vm-clamped-text';
import { trackLearnMoreClick } from 'Api/videos';

import Styles from './vm-video-info-cards.scss';

@customElement('vm-video-info-cards')
export class VmVideoInfoCards extends LitElement {
    static override styles = Styles;

    @property({ type: String }) description = '';
    @property({ type: String, attribute: 'content-action-info' }) contentActionInfo = '';
    @property({ type: String, attribute: 'content-action-url' }) contentActionUrl = '';
    @property({ type: String, attribute: 'video-slug' }) videoSlug = '';

    private renderDescriptionCard() {
        if (!this.description) return nothing;

        return html`
            <div class="vm-video-info-cards__card">
                <vm-clamped-text class="vm-video-info-cards__description" lines="2">
                    ${unsafeHTML(this.description)}
                </vm-clamped-text>
            </div>
        `;
    }

    private handleLearnMoreClick = () => {
        trackLearnMoreClick(this.videoSlug).catch();
    };

    private renderChannelDescriptionCard() {
        if (!this.contentActionInfo) return nothing;

        return html`
            <div class="vm-video-info-cards__card vm-video-info-cards__card--channel">
                <vm-clamped-text class="vm-video-info-cards__description" lines="2">
                    ${unsafeHTML(this.contentActionInfo)}
                </vm-clamped-text>
                ${this.contentActionUrl
                    ? html`<vm-button-next
                          class="vm-video-info-cards__learn-more"
                          hierarchy="quaternary"
                          href=${this.contentActionUrl}
                          size="md"
                          target="_blank"
                          rel="noopener noreferrer"
                          @click=${this.handleLearnMoreClick}
                          >Learn more</vm-button-next
                      >`
                    : nothing}
            </div>
        `;
    }

    override render() {
        if (!this.description && !this.contentActionInfo) return nothing;

        return html` ${this.renderDescriptionCard()} ${this.renderChannelDescriptionCard()} `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-video-info-cards': VmVideoInfoCards;
    }
}
